/*@flow*/
import type { Element } from 'react'; /** @jsx jsx */
import { useContext } from 'react';
import { css, jsx } from '@emotion/core';
import cx from 'classnames';
import delay from 'lib/delay';
import isSmallScreen from 'lib/isSmallScreen';
import commands from './commands';
import BuilderContext from './Context';

export default (o: {
  resourceName: string,
  label: string,
}): Element<string> => {
  const ctx = useContext(BuilderContext);

  return (
    <a
      className={cx('btn', `resource-${o.resourceName}`)}
      css={css(`
      padding: 15px !important;
      text-transform: initial;
      color: #EF7C2C !important;
      border: solid 1px #EF7C2C;
      font-weight: bold;
      margin-right: 10px !important;
      &:hover {
        border-color: #EF7C2C;
      }
      @media(max-width: 600px) {
        width: 100%;
      }
    `)}
      onClick={() => {
        // Transition is too quick in mobile phones.
        const amount = isSmallScreen() ? 500 : 0;
        delay(amount).then(() => {
          commands(ctx).selectResource(o.resourceName);
          commands(ctx).showForm();
        });
      }}
    >
      {o.label}
    </a>
  );
};
